var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('introduction'),_c('date-selector'),_c('visualization-old'),_c('visualization-line'),_c('visualization-line-bauer'),_c('visualization-line-neg'),_c('bottom-information'),_c('footSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }